import React from 'react';

export default class Button extends React.Component {

  getClasses() {
    let classes = '';
    if (!this.props.naoUsaClassebtn) {
      classes = 'btn ';
    }
    if (this.props.disabled) {
      classes += ' disabled ';
    }
    if (this.props.hidden) {
      classes += ' hidden';
    }
    classes += ' ' + this.props.className;
    return classes;
  }

  render() {
    return (
      <button {...this.props}
              type="button"
              className={this.getClasses()}>
        {this.props.icon && <i className={'fa ' + this.props.icon} />}
        {this.props.label &&
          <span className="ml-5">
            {this.props.label}
          </span>}
      </button>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/Button.jsx